// ※サーバから返ってきている情報を使っている項目で、ページに反映されないデータもあるので注意
const imgPath = '/static/img/yearluck/y2023/'
const dirKey = 'shiuma'

const info = {
  name: 'シウマ',
  itemId: 6403,
  lpId: 0, //なければ0
  pkgTitle: '暮れの酉の2022年のあなたの運勢あああああああああああああああ',
  price: 999,
  memberPrice: 500,
  pkgDescription: 'パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。',
  pkgNotice: '※この商品は、占いサイト『琉球風水志シウマ◇1分開運数意学』の「シウマの特別鑑定◆2023年上半期の詳細十大運勢」の一部と同じ内容のものになります。',
}

const top = {
  thumbnail: `${imgPath}top/counselor/${dirKey}/top_thumnail.png`,
  pkgTitleImg: `${imgPath}top/counselor/${dirKey}/top_pkg_title_img.png`,
  pkgBackImg: `${imgPath}top/counselor/${dirKey}/top_bg.png`,
}

const input = {
  thumbnail: `${imgPath}input/counselor/${dirKey}/input_thumnail.png`,
  fukiImage: `${imgPath}input/counselor/${dirKey}/input_fuki.png`,
  pkgBackImg: `${imgPath}input/counselor/${dirKey}/bg_topinfo.png`,
  headInfoBgUpp: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_upper.png`,
  headInfoBgMdl: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_middle.png`,
}

const result = {
  title: 'シウマの特別鑑定<br>◆2023年上半期の詳細10大運勢				',
  thumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  underThumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  description: '今日は鑑定に来てくださって、ありがとうございます。生まれ持った変えられない数字「生年月日」から占っていきますね。簡単にできる開運法もお伝えするので、ぜひ活用いただけるとうれしいです。',
  bottomFukiMessage: '鑑定はいかがでしたか？　あなたの新しい1年が、楽しく充実した年になりますように！',
}

export default {
  info,
  top,
  input,
  result,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/YearLuck/y2023/data/counselor/pkg03_shiuma.js